<template>
<div style="height: 100%">
  <div style="height: 40px">
    <el-date-picker v-fixZoom v-model="day" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="false" style="width: 140px" > </el-date-picker>
     <el-time-picker v-fixZoom :clearable="false" is-range v-model="time"
                    range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                    value-format="HH:mm" format="HH:mm" placeholder="选择时间范围"
                    style="width: 200px" >
    </el-time-picker>
    <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
  </div>
  <div style="height: calc(100% - 140px)">
<!--    <div v-if="mapType === 0" class="icon-map" @click="addOrRemove">-->
<!--      <div style="padding-top: 8px"><img v-if="isAdd" src="../../../assets/icon/map_blue.png"><img v-else src="../../../assets/icon/map_gray.png"> </div>-->
<!--      <div style="margin-top: 6px"><span v-if="isAdd" style="color: #1eb2ff">卫星</span><span v-else style="color: #8e8e8e">卫星</span></div>-->
<!--    </div>-->
    <iframe id="mainIframe" ref="mainIframe" name="mainIframe"
            :style="{width: '100%', height: '100%', margin: 'auto', zoom: 1 / this.golobleObject.zoom}"
            src="../../../../static/trackMap.html" frameborder="0" scrolling="no">
    </iframe>
  </div>
  <div style="height: 45px;margin-top: 20px;">
    <el-row>
      <el-col :span="4">
        <el-button size="mini" type="success" plain v-if="status === 'stop' && trackArr.length > 0" icon="el-icon-video-play" style="margin: 0 10px;font-size: 20px" @click="startTrack">
<!--          <img style="vertical-align: sub" src="../../../assets/icon/green_play1.png">-->
        </el-button>
        <el-button size="mini" type="warning" plain v-if="status === 'play' || status === 'resume'" style="margin: 0 10px;font-size: 20px" icon="el-icon-video-pause" @click="pauseTrack">
<!--          <img style="vertical-align: sub" src="../../../assets/icon/red_pause1.png">-->
        </el-button>
        <el-button size="mini" type="success" plain v-if="status === 'pause'" icon="el-icon-video-play" style="margin: 0 10px;font-size: 20px" @click="resumeTrack">
<!--          <img style="vertical-align: sub" src="../../../assets/icon/green_play1.png">-->
        </el-button>
        <el-button size="mini" type="danger" plain v-if="trackArr.length > 0" icon="el-icon-switch-button" style="margin: 0 10px;font-size: 20px" @click="stopTrack">
<!--          <img style="vertical-align: sub" src="../../../assets/icon/red_stop1.png">-->
        </el-button>

        <el-button size="mini" type="success" plain v-if="trackArr.length === 0"  icon="el-icon-video-play" style="margin: 0 10px;cursor: not-allowed;font-size: 20px">
<!--          <img style="vertical-align: sub" src="../../../assets/icon/green_play1.png">-->
        </el-button>
        <el-button size="mini" type="danger" plain v-if="trackArr.length === 0" icon="el-icon-switch-button" style="margin: 0 10px;cursor: not-allowed;font-size: 20px">
<!--          <img style="vertical-align: sub" src="../../../assets/icon/red_stop1.png">-->
        </el-button>
      </el-col>
      <el-col :span="20">
        <div v-if="trackArr.length > 0" style="margin-left: 20px;width: 500px;font-size: 14px;color: #1a1a1a">
          <div style="width: 100%;height: 20px;line-height: 20px">
            <span style="float: left">{{ (curPoint + 1) + ' / ' + (totalPoint + 1) }}</span>
            <span style="float: right">{{ curTime }}</span>
            <span style="float: right">{{ curLngLat }} &nbsp;&nbsp;&nbsp;</span>
<!--            <span style="float: right">{{ curRtkType }} &nbsp;&nbsp;&nbsp;</span>-->
          </div>
          <div style="width: 100%;height: 30px;line-height: 30px">
            <i v-if="status === 'stop' || status === 'pause'" class="el-icon-minus" style="cursor: pointer;float: left;margin-top: 12px;" @click="lessStep"></i>
            <el-slider :style="status === 'stop' || status === 'pause' ? {width: 'calc(100% - 60px)', float: 'left', margin: '0 15px'} : {width: '100%'}"
                       v-model="curPoint" :max="totalPoint" :show-tooltip="false" @input="sliderInput"></el-slider>
            <i v-if="status === 'stop' || status === 'pause'" class="el-icon-plus" style="cursor: pointer;float: left;margin-top: 12px;" @click="moreStep"></i>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {querydevicehistoryposition} from '../../../api/device'

export default {
  name: 'historyMapTrack',
  model: {
    prop: 'trackShow',
    event: 'change'
  },
  props: {
    trackObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      day: '',
      time: ['00:00', '23:59'],

      mapType: -1,
      isAdd: false,
      isSeeDetail: false,

      // 轨迹数据
      trackArr: [],
      // 路径
      lineArr: [], // [{start: int, lastTime: string, paths: []}] 根据ptime分多段路线
      passedPaths: [], // [paths, paths] 滑块拖动的路线
      pathArr: [], // [paths, paths] 路线数组
      // 全部路线
      polyLine: null,
      // 走过路线
      passedPolyLine: null,
      // 播放状态
      status: 'stop',
      // 当前状态
      curLine: 0, // 当前播放到第几段路线
      dragLine: -1, // 拖动到第几段路线
      dragPoint: 0, // 拖动了几个点(每段)
      curPoint: 0, // 当前点(所有段)
      totalPoint: 0, // 点总数

      curTime: '',
      curLngLat: ''
      // curRtkType: ''
    }
  },
  created () {
    this.golobleObject.initMapCompleted = this.initMapCompleted
    this.golobleObject.markerEvent = this.markerEvent
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    this.day = new Date().format('yyyy-MM-dd')
    // this.onSubmit()
  },
  mounted () {
  },
  methods: {
    initMapCompleted () {
      this.onSubmit()
    },
    onSubmit () {
      let imei = ''
      if (this.trackObj.type === 'device') { // 设备管理
        imei = this.trackObj.deviceRow.deviceid
      } else if (this.trackObj.type === 'alarm') { // 事件处理 弹窗
        imei = this.trackObj.alarmRow.device.deviceid
      }
      let data = {
        imei: imei,
        from: this.day + ' ' + this.time[0],
        to: this.day + ' ' + this.time[1]
      }
      querydevicehistoryposition(data).then(res => {
        if (res.data.devicepositions.length > 0) {
          this.showTrack(res.data.devicepositions)
        }
      }).catch(() => {})
    },

    // 外部调用
    async showTrack (trackArr) {
      await this.delTrack()

      this.trackArr = trackArr
      let person = trackArr[0]
      let lat = parseFloat(person.lat)
      let lng = parseFloat(person.lng)
      let maxLng = parseFloat(person.lng)
      let maxLat = parseFloat(person.lat)
      let minLng = parseFloat(person.lng)
      let minLat = parseFloat(person.lat)
      window.frames['mainIframe'].window.showOneTrackDevice(person)
      // 初始化数据
      this.lineArr = []
      this.pathArr = []
      this.passedPaths = []
      this.curLine = 0
      this.dragLine = -1
      this.dragPoint = 0
      this.curPoint = 0
      this.totalPoint = this.trackArr.length - 1
      this.curTime = trackArr[0].ptime
      this.curLngLat = lng + ' , ' + lat

      trackArr.forEach((track, index) => {
        let lat = parseFloat(track.lat)
        let lng = parseFloat(track.lng)
        if (lng > maxLng) maxLng = lng
        if (lat > maxLat) maxLat = lat
        if (lng < minLng) minLng = lng
        if (lat < minLat) minLat = lat

        // 按ptime划分多段路线(目前是1分钟)
        if (this.lineArr.length === 0) {
          let obj = {
            start: index,
            paths: [[lng, lat]],
            lastTime: track.ptime
          }
          this.lineArr.push(obj)
        } else {
          let line = this.lineArr[this.lineArr.length - 1]
          if (this.util.getDateDiff(line.lastTime, track.ptime, 'minute') > 6) {
            let obj = {
              start: index,
              paths: [[lng, lat]],
              lastTime: track.ptime
            }
            this.lineArr.push(obj)
          } else {
            line.lastTime = track.ptime
            line.paths.push([lng, lat])
          }
        }
      })
      this.lineArr.filter((value) => {
        this.pathArr.push(value.paths)
      })
      console.log(888, this.lineArr, this.pathArr)
      window.frames['mainIframe'].window.showTrack(this.pathArr)
      window.frames['mainIframe'].window.setTrackZoomAndCenter(maxLng, maxLat, minLng, minLat)
    },
    // 删除轨迹
    delTrack () {
      this.trackArr = []
      this.isSeeDetail = false
      // this.tableRowIndex = 0
      this.status = 'stop'
      this.lineArr = []
      this.pathArr = []
      this.passedPaths = []
      this.dragLine = -1
      this.dragPoint = 0
      this.curLine = 0
      this.curPoint = 0
      this.totalPoint = 0
      this.curTime = ''
      this.curLngLat = ''
      window.frames['mainIframe'].window.removeTrackDevice()
      window.frames['mainIframe'].window.removeTrack()
    },
    addOrRemove () {
      this.isAdd = !this.isAdd
      if (!this.isAdd) {
        window.frames['mainIframe'].window.removeLayer()
      } else {
        window.frames['mainIframe'].window.addLayer()
      }
    },
    markerEvent (obj) {
      if (obj.type === 'moving') {
        this.markerMoving(obj.e)
      } else if (obj.type === 'moveAlong') {
        this.markerMovealong(obj.e)
      }
    },
    markerMoving (e) {
      let vm = this
      if (this.status === 'stop' || this.status === 'pause') {
        return
      }

      let passedPath = []
      if (this.dragLine === this.curLine) {
        // 滑块拖动情况
        this.passedPaths.filter(value => {
          passedPath.push(vm.clone(value))
        })
        for (let i = 1; i < e.passedPath.length; i++) {
          passedPath[vm.dragLine].push(e.passedPath[i])
        }
      } else {
        // 自动播放情况
        if (this.curLine > 0) {
          for (let i = 0; i < this.curLine; i++) {
            passedPath.push(vm.lineArr[i].paths)
          }
        }
        passedPath.push(e.passedPath)
      }
      window.frames['mainIframe'].window.setPassedPath(passedPath)
      this.curPoint = this.dragLine === this.curLine ? this.lineArr[this.curLine].start + this.dragPoint + e.passedPath.length - 1 : this.lineArr[this.curLine].start + e.passedPath.length - 1
      this.curTime = this.trackArr[this.curPoint].ptime
      this.curLngLat = e.passedPos[0] + ' , ' + e.passedPos[1]
    },
    markerMovealong (e) {
      let vm = this
      if (this.curLine === this.lineArr.length - 1) {
        this.status = 'stop'
      } else {
        setTimeout(function () {
          vm.curLine += 1
          vm.startTrack()
        }, 500)
      }
    },
    startTrack () {
      let vm = this
      if (this.curPoint === this.totalPoint) {
        this.stopTrack()
      }
      let movePath = []
      if (this.dragLine === this.curLine) {
        // 滑块拖动情况
        if (this.dragPoint === this.pathArr[this.dragLine].length - 1) {
          // 滑块刚好拖动到当前线段的最后一个点，开始下一线段
          this.curLine += 1
          movePath = this.lineArr[this.curLine].paths
        } else {
          for (let i = this.dragPoint; i < this.pathArr[this.curLine].length; i++) {
            movePath.push(vm.pathArr[vm.curLine][i])
          }
        }
      } else {
        // 自动播放情况
        movePath = this.lineArr[this.curLine].paths
      }
      this.status = 'play'
      if (movePath.length > 1) {
        window.frames['mainIframe'].window.startMove(movePath)
      } else {
        this.curLine += 1
        this.curPoint += 1
        this.startTrack()
      }
    },
    stopTrack () {
      // if (this.$refs.detailTable) {
      //   this.$refs.detailTable.bodyWrapper.scrollTop = 0
      // }

      window.frames['mainIframe'].window.stopMove()
      this.status = 'stop'
      this.passedPaths = []
      window.frames['mainIframe'].window.setPassedPath(null)
      this.curLine = 0
      this.dragLine = -1
      this.dragPoint = 0
      this.curPoint = 0
      this.totalPoint = this.trackArr.length - 1
      this.curTime = this.trackArr[0].ptime
      this.curLngLat = parseFloat(this.trackArr[0].lng) + ' , ' + parseFloat(this.trackArr[0].lat)
    },
    pauseTrack () {
      window.frames['mainIframe'].window.pauseMove()
      this.status = 'pause'
    },
    resumeTrack () {
      window.frames['mainIframe'].window.resumeMove()
      this.status = 'resume'
    },
    lessStep () {
      if (this.curPoint === 0) {
        return
      }
      this.curPoint -= 1
    },
    moreStep () {
      if (this.curPoint === this.totalPoint) {
        return
      }
      this.curPoint += 1
    },
    sliderInput (index) {
      if (this.status === 'play' || this.status === 'resume') {
        return
      }
      window.frames['mainIframe'].window.stopMove()
      this.status = 'stop'
      let vm = this
      let passedPath = []
      let indexPoint = 0
      // 判断滑块拖动到哪个线段哪个点
      for (let i = 0; i < this.lineArr.length; i++) {
        if (index <= vm.lineArr[i].start + vm.lineArr[i].paths.length - 1) {
          vm.curLine = i
          indexPoint = index - vm.lineArr[i].start
          break
        }
      }
      this.pathArr.filter((path, i) => {
        if (i < vm.curLine) {
          passedPath.push(vm.clone(path))
        } else if (i === vm.curLine) {
          passedPath.push([])
          for (let j = 0; j <= indexPoint; j++) {
            passedPath[passedPath.length - 1].push(vm.clone(path[j]))
          }
        }
      })
      this.status = 'stop'
      this.dragLine = index === 0 ? -1 : this.curLine
      this.dragPoint = indexPoint
      this.curPoint = index
      this.curTime = this.trackArr[this.curPoint].ptime
      this.curLngLat = this.trackArr[this.curPoint].lng + ' , ' + this.trackArr[this.curPoint].lat
      this.passedPaths = passedPath
      if (passedPath.length > 0) {
        window.frames['mainIframe'].window.setPassedPath(passedPath)
        window.frames['mainIframe'].window.toMove(this.trackArr[this.curPoint].lng, this.trackArr[this.curPoint].lat)
      }
    }
  }
}
</script>

<style scoped>
.icon-map{
  position: absolute;
  top: 20px;
  left: 20px;
  width: 40px;
  height: 80px;
  background-color: #FFFFFF;
  box-shadow: 0 0 10px 0 #999999;
  border-radius: 4px;
  z-index: 999;
  cursor: pointer;
  text-align: center;
}
.blue-btn{
  padding: 0 10px;
  height: 40px;
  background-color: rgba(40, 150, 212, 1);
  border-radius: 5px;
  border: solid 1px #2896d4;
  font-family: SourceHanSansCN-Regular!important;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 1px;
  color: #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/historyMapTrack.vue